import { useMemo } from 'react';

import { useField } from 'react-final-form';

import type { AudienceBuilderAllowedFilter } from '../../../../../../../shared/types';

type Result = ModelHookResult<{
	filterSelected: AudienceBuilderAllowedFilter | undefined;
}>;

export function useFilterValueField({
	fieldTypeName,
	allowedFilters,
}: {
	fieldTypeName: string;
	allowedFilters: readonly AudienceBuilderAllowedFilter[];
}): Result {
	const { input: filterTypeInput } = useField<string>(fieldTypeName);

	const filterSelected = useMemo(
		() => allowedFilters.find((f) => f.type === filterTypeInput.value),
		[allowedFilters, filterTypeInput.value],
	);

	return {
		data: {
			filterSelected,
		},
	};
}
